module.exports = __webpack_public_path__ + "img/description3.3ecc4735.jpg";